export default __webpack_public_path__ + "static/media/haplotype.6e37b3f1.png";